import Styled from 'styled-components';
import { PageHeader } from 'antd';

const PageHeaderStyle = Styled(PageHeader)`
  margin-bottom: 25px;
  
  .page-header-actions button.ant-btn-white svg {
    width: 12px;
    height: 12px;
    ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 2px;
    color: #5f63f2;
  }
  i +span, svg +span, img +span {
      ${({ theme }) => (!theme.rtl ? 'margin-left' : 'margin-right')}: 6px;
  }

  /* Hladanie je v podnadpise hlavicky, a antd 4 dava podnadpisu
     overflow: hidden a white-space: nowrap. Pri uzsom okne sa policko
     odrezalo a vyzeralo to, ze hladanie v sekcii vobec nie je.
     Doplnene 21.9.2026 po tom, co to Adrian nahlasil. */
  .ant-page-header-heading-left {
    overflow: visible;
    flex-wrap: wrap;
    row-gap: 8px;
  }
  .ant-page-header-heading-sub-title {
    overflow: visible;
    white-space: normal;
    text-overflow: clip;
    max-width: 100%;
  }
`;

export { PageHeaderStyle };
